import $ from "jquery";

export function navbarToggler() {
  $(document).ready(function() {
    if ($(".full-screen-map").length == 0 && $(".bd-docs").length == 0) {
      // On click navbar-collapse the menu will be white not transparent
      $(".collapse")
        .on("show.bs.collapse", function() {
          $(this)
            .closest(".navbar")
            .removeClass("navbar-transparent")
            .addClass("bg-white");
        })
        .on("hide.bs.collapse", function() {
          $(this)
            .closest(".navbar")
            .addClass("navbar-transparent")
            .removeClass("bg-white");
        });
    }

    // Check if we have the class "navbar-color-on-scroll" then add the function to remove the class "navbar-transparent" so it will transform to a plain color.

    $(".form-control")
      .on("focus", function() {
        $(this)
          .parent(".input-group")
          .addClass("input-group-focus");
      })
      .on("blur", function() {
        $(this)
          .parent(".input-group")
          .removeClass("input-group-focus");
      });

    // Activate bootstrapSwitch
    $(".bootstrap-switch").each(function() {
      var data_on_label = $(this).data("on-label") || "";
      var data_off_label = $(this).data("off-label") || "";

      $(this).bootstrapSwitch({
        onText: data_on_label,
        offText: data_off_label,
      });
    });
  });

  $(document).on("click", ".navbar-toggle", function() {
    $("html").removeClass("nav-open");

    setTimeout(function() {
      $(this).removeClass("toggled");
      $("#bodyClick").remove();
    }, 550);

    setTimeout(function() {
      $(this).addClass("toggled");
    }, 580);

    let div = '<div id="bodyClick"></div>';
    $(div)
      .appendTo("body")
      .click(function() {
        $("html").removeClass("nav-open");

        setTimeout(function() {
          $(this).removeClass("toggled");
          $("#bodyClick").remove();
        }, 550);
      });

    $("html").addClass("nav-open");
  });

  $(window).resize(function() {
    // reset the seq for charts drawing animations

    if ($(".full-screen-map").length == 0 && $(".bd-docs").length == 0) {
      var is_iPad = navigator.userAgent.match(/iPad/i) != null;
      var scrollElement =
        navigator.platform.indexOf("Win") > -1 ? $(".main-panel") : $(window);
      let $navbar = $(".navbar");
      let isExpanded = $(".navbar")
        .find('[data-toggle="collapse"]')
        .attr("aria-expanded");
      if ($navbar.hasClass("bg-white") && $(window).width() > 991) {
        if (scrollElement.scrollTop() == 0) {
          $navbar.removeClass("bg-white").addClass("navbar-transparent");
        }
      } else if (
        $navbar.hasClass("navbar-transparent") &&
        $(window).width() < 991 &&
        isExpanded != "false"
      ) {
        $navbar.addClass("bg-white").removeClass("navbar-transparent");
      }
    }
    if (is_iPad) {
      $("body").removeClass("sidebar-mini");
    }
  });
}
